import React, { useState, useEffect, useRef } from "react";
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import InView from "react-intersection-observer";
import HeaderAnim from "../utils/animations/textRevealAnimation";
import { SlideInWithScroll } from "../utils/animations/slideInWithScroll";
import Parallax from "../utils/animations/parallax";
import { directions } from "../utils/animations/animationConstants";

export default function TwoRowImageText(props) {
  const { header, subHeader, intro, image, services, classes } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  const variants = {
    hidden: {
      opacity: 0,
      x: 200
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        damping: 50,
        stiffness: 500,
        delay: 0.3
      }
    }
  };
  const triggers = [[1, 0.9], [0.95, 0.85], [0.8, 0.7]];
  let serviceGrid = services.map((service, i) => {
    return <div key={i} id={"two-row-image-block" + i} className="col" /* triggers={triggers[i]} length={50} opacity={true} direction={directions.LTR} */>
      <div className="item-inner">
        <div className="item-content">
          <h5>{service.header}</h5>
          <p>{service.content}</p>
        </div>
      </div>
    </div>;

    //return <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints={[triggers[i], triggers[i + 2]]} key={i} />;
  });

  return (
    <InView onChange={(inView) => setIsVisible(inView)}>
      <div className="section-gap" id={props.id ? props.id : ''}>
        <div className="border-intro-section">
          <div className="container">
            <div className="border-intro-section-inner">
              <div className={`border-intro-top-block ${classes}`}>
                <div className="row d-flex flex-wrap">
                  <div className="col left-content-block">
                    {header && <p className="theme-color-title">{isVisible && <HeaderAnim header={header} />}</p>}
                    {subHeader && <h2 className="h3">{subHeader}</h2>}

                    <p>{intro}</p>
                  </div>
                  <motion.div
                    className="col right-image-block"
                    initial="hidden"
                    animate={isVisible ? "show" : "hidden"}
                    variants={variants}>
                    <img src={image} alt="digital product development team" title="Product Team" />
                  </motion.div>
                </div>
              </div>
              <div className={`border-intro-bottom-block ${classes}`}>
                <div className="row d-flex flex-wrap">
                  {services && serviceGrid}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </InView>
  );
}